import { Component, OnInit } from '@angular/core';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-ticketing',
  templateUrl: './ticketing.component.html',
  styleUrls: ['./ticketing.component.css']
})
export class TicketingComponent implements OnInit {
  package: any;
  category: any;
  extra: any;
  details: any;

  constructor(private userService:UserService,private route:Router,private modalService: NgbModal,private scrollToService: ScrollToService,) { }
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 5
      },
      900: {
        items: 8
      }
    },
    nav: false
  };
  ngOnInit(): void {
    this.getallCatogry();
    // this.pacbyCategory()
    this.triggerScrollTo();
  }

  getallCatogry(){
    let req ={
      statuses:[1],
    }
    this.userService.getallTicket(req).subscribe(
        res=>{

          this.package = res.data.content;
          this.extra = res.data;
        }
    )
  }

  catogrySearch(id){
    // let req ={
    //   type:id,
    // }
    // this.userService.getallCategorys(req).subscribe(
    //     res=>{
    //       this.package = res.data;
    //     }
    // )
  }

  search(pac) {
    console.log(pac)
    let ar: Array<any> = [];
    ar.push(pac);
    this.package=ar;
  }

  all() {
    this.package =this.extra;
  }

  booking(p: any) {
    localStorage.setItem('package',JSON.stringify(p));
    this.route.navigate(['/ticket-booking']);
  }

  open(content,details) {
    this.details=details;
    console.log(details);
    this.modalService.open(content, { centered: true });
  }

  custom(){
    this.route.navigate(['/index-custom-booking']);
  }

  // pacbyCategory() {
  //   let req ={
  //     type:'Ticketing',
  //   }
  //   this.userService.packageSearch(req).subscribe(
  //       res=>{
  //         this.package = res.data;
  //       }
  //   )
  // }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
